import { useState } from "react";
import { Grid, MenuItem, SelectChangeEvent } from "@mui/material";
import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import DeleteCaseModalContent from "./DeletionModals/DeleteCaseModalContent";
import DeleteAccountModalContent from "./DeletionModals/DeleteAccountModalContent";
import { ProductUnion } from "../../../types/ProductUnion";

type DeleteCaseOrAccountModalProps = {
  product: ProductUnion;
  refreshPage: Function;
  open: boolean;
  handleClose: Function;
};

export default function DeleteCaseOrAccountModalContent({
  product,
  open,
  handleClose,
  refreshPage,
}: DeleteCaseOrAccountModalProps) {
  const [deleteType, setDeleteType] = useState<"case" | "account" | string>("");

  async function postDeletionCallback() {
    await refreshPage();
    handleClose();
  }

  return (
    <LegalbirdIoModal handleClose={handleClose} open={open} title={"Daten löschen"} submitButton={null}>
      <p>Möchten Sie nur den Fall löschen, oder alle Daten und Fälle zu dem Nutzer?</p>
      <Grid container>
        <Grid size={12}>
          <ValidatorSelect
            label="Löschen von"
            name="deleteType"
            value={deleteType}
            onChange={(e: SelectChangeEvent) => {
              setDeleteType(e.target.value);
            }}
          >
            <MenuItem value={"case"}>Nur dieser Fall</MenuItem>
            <MenuItem value={"account"}>Alle Daten und Fälle</MenuItem>
          </ValidatorSelect>
          {deleteType === "case" && (
            <DeleteCaseModalContent product={product} postDeletionCallback={postDeletionCallback} />
          )}
          {deleteType === "account" && (
            <DeleteAccountModalContent product={product} postDeletionCallback={postDeletionCallback} />
          )}
        </Grid>
      </Grid>
    </LegalbirdIoModal>
  );
}
